import { FC } from 'react';
import { useAppSelector } from '../../redux/hooks';
import { selectUser } from '../../redux/reducers/userSlice';
import { getStudentInitials } from '../../businessLogicService/getStudentInitials';

/**
 * The "TOWARDS" marker: a circular avatar with the current student's initials followed by the label,
 * shown by UnitPathRail in place of the "Back to position" control while the student's position is on
 * screen — i.e. while they are already looking at their own progress. The avatar keeps the fixed
 * purple student tone used by the unit header's progress marker (it identifies the student, not the
 * unit), so it does not follow the unit color. Purely presentational; the rail owns its placement.
 */
export const TowardsMarker: FC = () => {
  const user = useAppSelector(selectUser);
  const initials = getStudentInitials(user);

  if (!initials) {
    return null;
  }

  return (
    <div className="tw-inline-flex tw-flex-row tw-items-center tw-gap-2 tw-pointer-events-none">
      <span
        data-hj-suppress
        className="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-border-solid tw-border-white tw-bg-purple-300 tw-text-purple-700 tw-font-atkinson tw-text-sm tw-font-bold tw-shadow"
      >
        {initials}
      </span>
      <span className="tw-text-[#0C1B54] tw-font-atkinson tw-text-sm tw-font-bold tw-tracking-wide">TOWARDS</span>
    </div>
  );
};

export default TowardsMarker;
